import { render } from "./VTextarea.vue?vue&type=template&id=88f8229a&ts=true"
import script from "./VTextarea.vue?vue&type=script&lang=ts"
export * from "./VTextarea.vue?vue&type=script&lang=ts"

import "./VTextarea.vue?vue&type=style&index=0&id=88f8229a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__